"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _utilityClassNames = require("@emcm-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

var _utilityRehydratableName = require("@emcm-ui/utility-rehydratable-name");

var _utilityRehydratableName2 = _interopRequireDefault(_utilityRehydratableName);

var _BaseItem = require("./components/BaseItem");

var _BaseItem2 = _interopRequireDefault(_BaseItem);

var _Column = require("./components/Column");

var _Column2 = _interopRequireDefault(_Column);

var _Item = require("./components/Item");

var _Item2 = _interopRequireDefault(_Item);

var _Login = require("./components/Login");

var _Login2 = _interopRequireDefault(_Login);

var _NavList = require("./components/NavList");

var _NavList2 = _interopRequireDefault(_NavList);

var _NavItem = require("./components/NavItem");

var _NavItem2 = _interopRequireDefault(_NavItem);

var _utilityAuthentication = require("@emcm-ui/utility-authentication");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalHeader = function (_Component) {
  _inherits(GlobalHeader, _Component);

  function GlobalHeader(props) {
    _classCallCheck(this, GlobalHeader);

    var _this = _possibleConstructorReturn(this, (GlobalHeader.__proto__ || Object.getPrototypeOf(GlobalHeader)).call(this, props));

    _this.onLoginManagerChange = function () {
      _this.forceUpdate();
    };

    if (props.loginManager) {
      props.loginManager.onChange(_this.onLoginManagerChange);
    }
    return _this;
  }

  _createClass(GlobalHeader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.loginManager) {
        this.props.loginManager.offChange(this.onLoginManagerChange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          leftItems = _props.leftItems,
          rightItems = _props.rightItems,
          loginManager = _props.loginManager;


      var loggedIn = loginManager && loginManager.authState === _utilityAuthentication.AuthState.LOGGED_IN;

      var getClassName = (0, _utilityClassNames2.default)(GlobalHeader.displayName);

      return _react2.default.createElement(
        "div",
        {
          className: getClassName({ modifiers: (0, _classnames2.default)({ loggedIn: loggedIn }) }),
          "data-rehydratable": (0, _utilityRehydratableName2.default)(GlobalHeader.displayName)
        },
        _react2.default.createElement(
          "div",
          { className: getClassName({ descendantName: "inner" }) },
          leftItems && _react2.default.createElement(
            "ul",
            {
              className: getClassName({
                descendantName: "leftItems"
              })
            },
            leftItems
          ),
          rightItems && _react2.default.createElement(
            "ul",
            {
              className: getClassName({
                descendantName: "rightItems"
              })
            },
            rightItems
          )
        )
      );
    }
  }]);

  return GlobalHeader;
}(_react.Component);

GlobalHeader.displayName = "GlobalHeader";

/* eslint-disable max-len */
GlobalHeader.propTypes = {
  /**
   * Child nodes to appear on left hand side. Should be GlobalHeader.Item wrapped in a `<React.Fragment />`.
   */
  leftItems: _propTypes2.default.node,
  /**
   * Child nodes to appear on right hand side. Should be GlobalHeader.Item wrapped in a `<React.Fragment />`.
   */
  rightItems: _propTypes2.default.node,
  /**
   * The LoginManager.
   */
  loginManager: _propTypes2.default.object
};

GlobalHeader.BaseItem = _BaseItem2.default;
GlobalHeader.Column = _Column2.default;
GlobalHeader.Item = _Item2.default;
GlobalHeader.Login = _Login2.default;
GlobalHeader.NavList = _NavList2.default;
GlobalHeader.NavItem = _NavItem2.default;

exports.default = GlobalHeader;